import { render } from "./ParticipantDetails.vue?vue&type=template&id=406d7591&scoped=true"
import script from "./ParticipantDetails.vue?vue&type=script&lang=js"
export * from "./ParticipantDetails.vue?vue&type=script&lang=js"

import "./ParticipantDetails.vue?vue&type=style&index=0&id=406d7591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406d7591"]])

export default __exports__